var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"x-large":"","color":_vm.isDark ? _vm.darkColor : _vm.brightColor,"elevation":"10"},on:{"click":function($event){return _vm.$emit("click")}}},[_c('div',{class:{'black--text' : !_vm.isDark}},[_c('div',[_vm._v("Sign Up")]),_c('div',{staticClass:"caption"},[_vm._v("We'll order a chip for you")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }